export default function resolveFullPath(parentPath: string, childPath?: string): string {
  if (!childPath) return parentPath;
  return childPath.startsWith('/')
    ? childPath
    : `${parentPath}/${childPath}`.replaceAll(/\/+/g, '/');
}
